const BACKEND_ERROR_TO_I18N_KEY = {
  'Leave request cannot start or end on a weekend': 'leave.weekendError',
  'Employee already has approved leave during this period': 'leave.overlapError',
  'Insufficient leave balance for the requested period': 'leave.insufficientBalanceError',
  'Can only update pending leave requests': 'leave.updatePendingOnlyError',
  'Cannot update a rejected leave request': 'leave.updateRejectedError',
  'Can only delete pending leave requests': 'leave.deletePendingOnlyError',
  'The ADMIN role can only be assigned directly in the database': 'employee.errors.adminRoleDbOnly',
  "An administrator's role can only be changed directly in the database": 'employee.errors.cannotDemoteAdmin',
  'Access denied: Only administrators can modify administrator accounts': 'employee.errors.adminAccountProtected',
};

const BANK_HOLIDAY_PREFIX = 'BANK_HOLIDAY_CONFLICT:';
// The backend appends the current status ("Leave request has already been approved"
// / "... rejected"), so this one is matched on its stable prefix.
const ALREADY_PROCESSED_PREFIX = 'Leave request has already been';

// Employee uniqueness/validation messages embed dynamic values; match them on a
// stable shape and re-localize with the extracted values interpolated. The taken
// messages carry the conflicting value plus a label for the account that owns it
// ("First Last (username)", or a bare username for accounts with no employee
// profile). The regexes are pinned by getApiErrorMessage.test.js so a backend
// wording change fails fast.
const USERNAME_TAKEN_PATTERN = /^Username '([^']*)' already in use by (.+)$/;
const EMAIL_TAKEN_PATTERN = /^Email '([^']*)' already in use by (.+)$/;
const INVALID_ROLE_PREFIX = 'Invalid role: ';
const INVALID_EMPLOYEE_TYPE_PREFIX = 'Invalid employee type: ';

const getApiErrorMessage = (error, fallbackKey, t) => {
  const backendMessage = error.response?.data?.message;

  if (backendMessage && backendMessage.startsWith(BANK_HOLIDAY_PREFIX)) {
    const dates = backendMessage.substring(BANK_HOLIDAY_PREFIX.length);
    return t('leave.bankHolidayError', { dates });
  }

  if (backendMessage && backendMessage.startsWith(ALREADY_PROCESSED_PREFIX)) {
    return t('leave.notPendingError');
  }

  if (backendMessage) {
    const usernameMatch = backendMessage.match(USERNAME_TAKEN_PATTERN);
    if (usernameMatch) {
      return t('employee.errors.usernameTaken', { username: usernameMatch[1], owner: usernameMatch[2] });
    }
    const emailMatch = backendMessage.match(EMAIL_TAKEN_PATTERN);
    if (emailMatch) {
      return t('employee.errors.emailTaken', { email: emailMatch[1], owner: emailMatch[2] });
    }
    if (backendMessage.startsWith(INVALID_ROLE_PREFIX)) {
      return t('employee.errors.invalidRole', { role: backendMessage.substring(INVALID_ROLE_PREFIX.length) });
    }
    if (backendMessage.startsWith(INVALID_EMPLOYEE_TYPE_PREFIX)) {
      return t('employee.errors.invalidEmployeeType', { type: backendMessage.substring(INVALID_EMPLOYEE_TYPE_PREFIX.length) });
    }
  }

  const exactKey = BACKEND_ERROR_TO_I18N_KEY[backendMessage];
  if (exactKey) {
    return t(exactKey);
  }

  return backendMessage || t(fallbackKey);
};

export default getApiErrorMessage;
